import FinancialTableBody from './FinancialTableBody';

export default FinancialTableBody;
